import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsuranceTypes } from 'src/app/models/database/insurance-type.model';
import { Insurance, Insurances } from 'src/app/models/database/insurance.model';
import { Patients } from 'src/app/models/database/patient';
import { Schedules } from 'src/app/models/database/schedule';
import { Id, Ids } from 'src/app/models/database/types/id.model';
import { HttpService } from '../http-service.service';

@Injectable({
  providedIn: 'root'
})
export class InsuranceService extends HttpService {

  constructor(private http: HttpClient) {
    super('insurance')
  }

  addStandardInsurances(insurancesIds: Ids): Observable<void> {
    return this.http.post<void>(`${this.url}/standard`, { insurancesIds })
  }

  addCustomInsurance(insurance: Insurance): Observable<void> {
    return this.http.post<void>(`${this.url}`, { insurance })
  }

  addPatients(insuranceId: Id, patientsIds: Ids): Observable<void> {
    return this.http.post<void>(`${this.url}/${insuranceId}/patients`, { patientsIds })
  }

  addSchedules(insuranceId: Id, schedulesIds: Ids): Observable<void> {
    return this.http.post<void>(`${this.url}/${insuranceId}/schedules`, { schedulesIds })
  }

  getInsuranceTypes(): Observable<InsuranceTypes> {
    return this.http.get<InsuranceTypes>(`${this.url}/types`)
  }

  getStandardInsurances(): Observable<Insurances> {
    return this.http.get<Insurances>(`${this.url}/standard`)
  }

  getInsurances(filter?: any): Observable<Insurances> {
    let url: string = `${this.url}/clinic`
    if (filter) {
      url += this.implementQueries(filter)
    }
    return this.http.get<Insurances>(url)
  }

  getOne(insuranceId: Id): Observable<Insurance> {
    return this.http.get<Insurance>(`${this.url}/${insuranceId}`)
  }

  getDoctors(insuranceId: Id): Observable<any> {
    return this.http.get<any>(`${this.url}/${insuranceId}/doctors`)
  }

  getPatients(insuranceId: Id): Observable<Patients> {
    return this.http.get<Patients>(`${this.url}/${insuranceId}/patients`)
  }

  getSchedules(insuranceId: Id, filter?: any): Observable<Schedules> {
    let url: string = `${this.url}/${insuranceId}/schedules`
    if (filter) {
      url += this.implementQueries(filter)
    }
    return this.http.get<Schedules>(url)
  }

  editCustomInsurance(insurance: Insurance): Observable<void> {
    return this.http.put<void>(`${this.url}/${insurance.id}`, { insurance })
  }

  deleteStandardInsurance(insuranceId: Id): Observable<void> {
    return this.http.delete<void>(`${this.url}/${insuranceId}/standard`)
  }

  deleteCustomInsurance(insuranceId: Id): Observable<void> {
    return this.http.delete<void>(`${this.url}/${insuranceId}/custom`)
  }

  deleteDoctor(insuranceId: Id, doctorId: Id): Observable<void> {
    return this.http.delete<void>(`${this.url}/${insuranceId}/doctor/${doctorId}`)
  }

  deletePatient(insuranceId: Id, patientId: Id): Observable<void> {
    return this.http.delete<void>(`${this.url}/${insuranceId}/patient/${patientId}`)
  }

  deleteSchedule(insuranceId: Id, scheduleId: Id): Observable<void> {
    return this.http.delete<void>(`${this.url}/${insuranceId}/schedule/${scheduleId}`)
  }

  verifyIfCodeExists(code: string): Observable<boolean> {
    return this.http.head<boolean>(`${this.url}/code/verify?code=${code}`)
  }
}